export const QueryParams = {
  STATUS: 'status',
  SHIPMENT_NUMBER: 'shipmentNumber',
  QUERY: 'query',
  COUNTRY: 'country',
  CUSTOMER: 'customer',
  ASSIGNMENT: 'assignment',
  CARRIER_HANDLE: 'carrierHandle',
  DATE_FROM: 'dateFrom',
  DATE_TO: 'dateTo',
}
